module.exports = __webpack_public_path__ + "static/media/SEND_MESSAGE_ICON.cc2e4214.svg";